import { TableTemplateV2 } from "../dashboard/TableTemplate-v2";
import { OutgoingReferralsDashboardTableWidgetFilters } from "../widget-filters/OutgoingReferralsDashboardTableWidgetFilters";
import { TableWidget } from "./TableWidget";

export class OutgoingReferralsDashboardTableWidget extends TableWidget {
    static getWidgetDashboardType() {
        return "Table";
    }

    static getWidgetMetadataType() {
        return "OutgoingReferralsDashboardTable";
    }

    static getWidgetResourceType() {
        return "Table";
    }

    static getFiltersComponent() {
        return OutgoingReferralsDashboardTableWidgetFilters;
    }

    constructor() {
        super();
    }

    public getSearchKey() {
        return "domain";
    }

    getProperties() {
        const props = super.getProperties();
        return props;
    }

    get templateUrl() {
        return `/app/components/widget/widget-templates/table.html`;
    }

    get templateComponent() {
        return TableTemplateV2;
    }

    _getProUrlParams() {
        return Object.assign(super._getProUrlParams(), {
            // eslint-disable-next-line @typescript-eslint/naming-convention
            outagoing_filters:
                typeof this.apiParams.filter === "string" && this.apiParams.filter.replace(/"/g, "").replace(",", "+"),
        });
    }
}
OutgoingReferralsDashboardTableWidget.register();
